/** Effective enablement for the in-house 3D walkthrough recorder (beta). */
export function isModelWalkthroughEnabled(opts: {
  globalDefault?: boolean;
  projectOverride?: boolean;
  /** Denormalized on portal project — preferred on public portal reads. */
  effectiveDenormalized?: boolean;
}): boolean {
  if (typeof opts.effectiveDenormalized === 'boolean') return opts.effectiveDenormalized;
  if (typeof opts.projectOverride === 'boolean') return opts.projectOverride;
  return opts.globalDefault ?? false;
}

export function computeModelWalkthroughEffective(opts: {
  globalDefault: boolean;
  projectOverride?: boolean;
}): boolean {
  return isModelWalkthroughEnabled({
    globalDefault: opts.globalDefault,
    projectOverride: opts.projectOverride,
  });
}

export type ModelWalkthroughProjectOverride = 'inherit' | 'on' | 'off';

export function parseWalkthroughProjectOverride(
  value: boolean | undefined | null,
): ModelWalkthroughProjectOverride {
  if (value === true) return 'on';
  if (value === false) return 'off';
  return 'inherit';
}
